var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"site-title",attrs:{"to":{ path: '/'}}},[_c('h1',{ref:"title",style:(_vm.titleStyle)},[_vm._v(_vm._s(_vm.text))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fa91e7d4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","vector":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SiteTitle.vue
// module id = ij/B
// module chunks = 0